import { render, staticRenderFns } from "./CategoryCascader.vue?vue&type=template&id=5609f762&lang=pug&"
import script from "./CategoryCascader.vue?vue&type=script&lang=js&"
export * from "./CategoryCascader.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCascader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports